if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.handleThemeVariantChange = this.handleThemeVariantChange.bind(this);
      this.syncCheckoutForm = this.syncCheckoutForm.bind(this);
      this.sectionId = this.dataset.section;
    }

    connectedCallback() {
      const mainForm = document.getElementById(this.dataset.productFormId);

      this.targetElement =
        mainForm?.querySelector('[name="add"]') ||
        document.querySelector('[id^="ProductSubmitButton-"]');
      this.footerElement = document.querySelector('footer');
      this.stickyAtcVariantInput = this.querySelector('.product-variant-id');
      this.checkoutButton = this.querySelector('[data-checkout-button]');
      this.checkoutLabel = this.dataset.checkoutLabel;
      this.stickyForm = this.querySelector('form');

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll);
      this.stickyForm?.addEventListener('submit', this.syncCheckoutForm, true);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleThemeVariantChange
        );
      }

      this.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
      this.stickyForm?.removeEventListener('submit', this.syncCheckoutForm, true);
      if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
    }

    handleScroll() {
      if (!this.targetElement || !this.footerElement) return;

      const targetRect = this.targetElement.getBoundingClientRect();
      const footerRect = this.footerElement.getBoundingClientRect();
      const shouldShow = targetRect.bottom <= 0 && footerRect.top > window.innerHeight;

      this.classList.toggle('show', shouldShow);
    }

    handleThemeVariantChange(event) {
      const data = event?.data;
      if (!data || data.sectionId !== this.sectionId || !data.variant) return;

      if (this.stickyAtcVariantInput) {
        this.stickyAtcVariantInput.value = data.variant.id;
        this.stickyAtcVariantInput.disabled = false;
      }

      if (this.checkoutButton && !this.checkoutButton.disabled) {
        const buttonText = this.checkoutButton.querySelector('span');
        if (buttonText) buttonText.textContent = this.checkoutLabel;
      }
    }

    syncCheckoutForm() {
      const mainForm = document.getElementById(this.dataset.productFormId);
      if (!mainForm || !this.stickyForm) return;

      ['quantity', 'selling_plan'].forEach((fieldName) => {
        const source = mainForm.querySelector(`[name="${fieldName}"]`);
        if (!source || !source.value) return;

        let destination = this.stickyForm.querySelector(`[name="${fieldName}"]`);
        if (!destination) {
          destination = document.createElement('input');
          destination.type = 'hidden';
          destination.name = fieldName;
          this.stickyForm.appendChild(destination);
        }
        destination.value = source.value;
      });
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}


